import { memo } from 'react';
import { ThemeProvider } from 'styled-components';
import { bool, func, element } from 'prop-types';
import { ResponsiveProvider } from '../../../decorators/responsive';
import MobileModal from '../../../components/popups/MobileModal';
import theme from '../../theme';
// с провайдером пока хак, пока не перепишем модалки на Portal (16pt)
const ModalLayout = ({
  isOpen,
  onClose,
  children
}) => /*#__PURE__*/React.createElement(MobileModal, {
  className: "modal-is-shown modal__datepicker",
  title: I18n.t('layout.search.datepicker.date'),
  isOpen: isOpen,
  onClose: onClose
}, /*#__PURE__*/React.createElement(ResponsiveProvider, null, /*#__PURE__*/React.createElement(ThemeProvider, {
  theme: theme
}, children)));
ModalLayout.propTypes = {
  isOpen: bool,
  onClose: func,
  children: element
};
export default /*#__PURE__*/memo(ModalLayout);